var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-tab-pane",
    {
      staticClass: "scroll-y",
      class: { "no-padding": _vm.customerProjects.length === 0 },
      attrs: { name: "projects" }
    },
    [
      _vm.customerProjects.length
        ? _c(
            "div",
            {
              directives: [{ name: "is-user", rawName: "v-is-user" }],
              staticClass: "row sticky-top q-mb-sm justify-between"
            },
            [
              _c("q-btn", {
                attrs: {
                  label: _vm.$tc("project", 1),
                  icon: "add",
                  color: "gray",
                  flat: ""
                },
                on: { click: _vm.handleCreateProject }
              }),
              _c("q-btn", {
                attrs: {
                  label: _vm.$t("settle_customer_projects"),
                  colror: "gray",
                  flat: ""
                },
                on: { click: _vm.handleSettleCustomerProjects }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.customerProjects.length
        ? _c(
            "q-scroll-area",
            {
              staticClass: "full-width customer-card__tab-scroll",
              attrs: {
                "thumb-style": {
                  width: "5px",
                  "background-color": "#555",
                  opacity: 1
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "row gutter-sm" },
                _vm._l(_vm.customerProjects, function(project) {
                  return _c(
                    "div",
                    { key: project.id, staticClass: "col-12 col-md-6" },
                    [_c("project-card", { attrs: { project: project } })],
                    1
                  )
                })
              )
            ]
          )
        : [
            _c(
              "div",
              {
                staticClass: "row justify-center items-center col-grow q-pt-lg"
              },
              [
                _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c("img", {
                      attrs: {
                        src: require("assets/emptystates/projects_empty.svg"),
                        height: "100px"
                      }
                    }),
                    _c("h6", { staticClass: "q-my-md text-faded" }, [
                      _vm._v(_vm._s(_vm.$t("projects_empty")))
                    ]),
                    _c(
                      "q-btn",
                      {
                        staticClass: "q-mt-lg",
                        attrs: { color: "primary", outline: "" },
                        on: { click: _vm.handleCreateProject }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("create_project")) +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ],
      _c("project-modal", {
        ref: "createProjectModal",
        attrs: { customer: _vm.customer },
        on: { save: _vm.handleSaveProject }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }